<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <tree-select-vue
      ref="treeSelectRef"
      v-if="modalConfig.visible"
      style="width: 340px"
      :multiple="props.multiple"
    ></tree-select-vue>
  </a-modal>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import treeSelectVue from "@/components/chooseStaff/staff.vue";

export default defineComponent({
  components: {
    treeSelectVue,
  },
  props: {
    multiple: Boolean,
  },
  setup(props, context) {
    const treeSelectRef = ref();

    const handleOk = () => {
      const { noticeStaffString, staffName, staffUserName } =
        treeSelectRef.value.getChooseStaff();
      context.emit(
        "handleSelectStaff",
        noticeStaffString,
        staffName,
        staffUserName
      );

      closeModal();
    };

    const closeModal = () => {
      treeSelectRef.value.clearSelect();
      modalConfig.visible = false;
    };

    const modalConfig = reactive({
      title: "推送",
      visible: false,
    });

    const handleCancel = () => {
      closeModal();
    };

    const showModal = () => {
      modalConfig.visible = true;
    };
    return {
      props,
      modalConfig,
      treeSelectRef,
      handleOk,
      handleCancel,
      showModal,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
